export { default as SendBirdProvider } from './SendbirdProvider.js';
export { default as App } from './App.js';
export { default as ChannelSettings } from './ChannelSettings.js';
export { default as ChannelList } from './ChannelList.js';
export { default as Channel, getAllEmojisFromEmojiContainer, getEmojiCategoriesFromEmojiContainer, getEmojisFromEmojiContainer } from './Channel.js';
import { S as SendbirdSdkContext } from './LocalizationContext-dfe8b78b.js';
export { g as getStringSet, w as withSendBird } from './LocalizationContext-dfe8b78b.js';
export { default as OpenChannel } from './OpenChannel.js';
export { default as OpenChannelSettings } from './OpenChannelSettings.js';
export { default as MessageSearch } from './MessageSearch.js';
export { s as sendBirdSelectors } from './index-cb0d7936.js';
import { useContext } from 'react';
import 'prop-types';
import 'sendbird';
import './actionTypes-3af77038.js';
import 'css-vars-ponyfill';
import './index-fe1a6d27.js';
import './LeaveChannel-42fd86b9.js';
import './index-1fe82074.js';
import './index-db1485c0.js';
import './utils-7b22e0fc.js';
import './index-d85ca28f.js';
import './index-d3cbd48c.js';
import './index-0cc16758.js';
import './index-8312f99e.js';
import 'react-dom';
/**
 * Example:
 * const MyComponent = () => {
 *  const context = useSendbirdStateContext();
 *  const sdk = sendbirdSelectors.getSdk(context);
 *  return (<div>...</div>);
 * }
 */

function useSendbirdStateContext() {
  var context = useContext(SendbirdSdkContext);
  return context;
}

export { useSendbirdStateContext };